import { Text } from "@zapier/design-system";
import styles from "./RelatedContent.module.css";
import { BlogCard } from "./BlogCard";
import { ZapCardTemplate } from "src/components/ZapCard";

interface RelatedTemplatesProps {
  template: ZapCardTemplate;
}

export const RelatedContent = ({ template }: RelatedTemplatesProps) => {
  if (!template.relatedContent || template.relatedContent.items.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={styles.sectionTitle}>
        <Text tag="h2" type="PageHeader">
          Related Resources
        </Text>
      </div>
      <div className={styles.content}>
        {template.relatedContent?.items.map((content) => (
          <BlogCard key={content.title} {...content} />
        ))}
      </div>
    </div>
  );
};
